import React, { ReactNode } from "react";
// import styled from "@emotion/styled";
import Carousel from "@brainhubeu/react-carousel";
import "@brainhubeu/react-carousel/lib/style.css";
import { ArrowCarousel } from "../ArrowCarousel";

// == Types ================================================================

interface IProps {
  children: ReactNode;
  itemLength: number;
}

// == Constants ============================================================

// == Component ============================================================

const MultiItemCarousel = ({ children, itemLength, ...rest }: IProps) => {
  return (
    <Carousel
      addArrowClickHandler
      infinite
      keepDirectionWhenDragging
      animationSpeed={1500}
      arrowLeft={<ArrowCarousel arrowDirection="left" indent={[0, 0, 0, -20, -35]} />}
      arrowRight={<ArrowCarousel arrowDirection="right" indent={[0, 0, 0, -20, -35]} />}
      breakpoints={{
        768: {
          slidesPerPage: 3,
          slidesPerScroll: 3,
        },
        992: {
          slidesPerPage: 4,
          slidesPerScroll: 4,
        },
      }}
      draggable={false}
      slidesPerPage={5}
      slidesPerScroll={5}
      {...rest}
    >
      {children}
    </Carousel>
  );
};

export default MultiItemCarousel;

// == Styles ===============================================================
